module.exports = __webpack_public_path__ + "static/BT-mobile-4-dc2973222bb467393f34a0424a83757c.jpg";